/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Promo_Bodydetail1Inputs */

const ja_playdata_home_promo_bodydetail1 = /** @type {(inputs: Playdata_Home_Promo_Bodydetail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料レポートご希望の際はお問い合わせください。`)
};

const en_playdata_home_promo_bodydetail1 = /** @type {(inputs: Playdata_Home_Promo_Bodydetail1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact us to get your free copy.`)
};

/**
* | output |
* | --- |
* | "Contact us to get your free copy." |
*
* @param {Playdata_Home_Promo_Bodydetail1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_home_promo_bodydetail1 = /** @type {((inputs?: Playdata_Home_Promo_Bodydetail1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Promo_Bodydetail1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_promo_bodydetail1(inputs)
	return en_playdata_home_promo_bodydetail1(inputs)
});
export { playdata_home_promo_bodydetail1 as "playdata_home_promo_bodyDetail" }